export const APP_ID = 'CMS';
